import React from 'react';
import { Button } from './ui';

const NameModal = ({ isOpen, pendingName, onChangePendingName, onCancel, onSave }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-secondary-90/60 backdrop-blur-sm px-4">
      <div className="bg-surface rounded-2xl shadow-xl border border-accent-40 max-w-md w-full p-6">
        <div className="mb-4">
          <p className="text-xs font-semibold uppercase tracking-wide text-primary-70 mb-1">
            Let&apos;s get to know you
          </p>
          <h2 className="text-xl font-semibold text-secondary mb-2">
            What should we call you?
          </h2>
          <p className="text-sm text-secondary-70">
            This name will appear next to your questions and will be used to identify you throughout the app.
          </p>
        </div>
        <div className="space-y-3">
          <div>
            <label htmlFor="initial-name" className="block text-sm font-medium text-secondary mb-2">
              Your Name
            </label>
            <input
              id="initial-name"
              type="text"
              value={pendingName}
              onChange={(e) => onChangePendingName(e.target.value)}
              placeholder="Enter your name"
              maxLength={60}
              className="w-full px-4 py-3 bg-accent-20 text-xs border border-accent rounded-lg focus:ring-2 focus:ring-primary-50 focus:border-primary transition-colors placeholder-secondary-60"
              autoFocus
            />
            <p className="text-xs text-secondary-60 mt-1">
              You can always update this later.
            </p>
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <Button
              type="button"
              variant="secondary"
              size="sm"
              onClick={onCancel}
            >
              Not now
            </Button>
            <Button
              type="button"
              variant="primary"
              size="sm"
              disabled={!pendingName.trim()}
              onClick={onSave}
            >
              Save name
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NameModal;

